import { connect } from 'react-redux';
import { List } from 'immutable';
import decorate from '../../utils/decorate';

import { request } from '../../modules/tags/actions/edit';
import { request as queryTags } from '../../modules/tags/actions/query';

import TagManagement from './TagManagement.jsx';

function mapStateToProps(state) {
    return {
        sports: state.sports.get('items').toList(),
        tags: state.tags.get('items')
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onEditTagRequest: (id, data) => dispatch(request(id, data)),
        onQueryTagsRequest: () => dispatch(queryTags('tags'))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    TagManagement
);
